import { StatusCode } from '@/modules/asset/constants';
import { User } from '@/modules/user/types';
import { computed, Ref } from '@vue/composition-api';
import { useFeatureFlags } from './feature-flags';

export function useNavigationItems(user: Ref<User>, isModelModerator: Ref<boolean>, isAdmin: Ref<boolean>) {
    const { isEnabled: isFeatureEnabled, areAnyEnabled: areAnyFeaturesEnabled } = useFeatureFlags();
    const defaultAssetStatus = Object.values(StatusCode).filter(
        (statusCode: StatusCode) => ![StatusCode.Deleted, StatusCode.Archived].includes(statusCode),
    );

    const navigation = computed(() =>
        [
            {
                name: 'Data Pipelines',
                route: 'data-checkin-jobs',
                icon: 'solar:round-transfer-diagonal-broken',
                exact: false,
                visible: !!user.value?.organisationId,
            },
            {
                name: 'Data Assets',
                route: 'assets',
                query: { status: defaultAssetStatus.join(','), reset: true },
                icon: 'solar:database-broken',
                exact: false,
                visible: !!user.value?.organisationId,
            },
            {
                name: 'Analytics',
                route: 'workflows',
                icon: 'solar:colour-tuneing-broken',
                exact: false,
                visible: isFeatureEnabled('analytics') && !!user.value?.organisationId,
            },
            {
                name: 'Dashboards',
                href: process.env.VUE_APP_DASHBOARD_BUILDER,
                icon: 'solar:diagram-down-broken',
                exact: false,
                visible: isFeatureEnabled('dashboard.builder') && !!user.value?.organisationId,
            },
            {
                name: 'Data Retrieval',
                route: 'retrieval',
                icon: 'solar:diagram-down-broken',
                exact: false,
                visible:
                    areAnyFeaturesEnabled(['retrieve.api', 'retrieve.files', 'retrieve.stream']) &&
                    !!user.value?.organisationId,
            },
            {
                name: 'Contracts',
                route: 'contracts',
                icon: 'solar:document-linear',
                exact: false,
                visible: isFeatureEnabled('sharing') && !!user.value?.organisationId,
            },
            {
                name: 'Data Models',
                route: 'model-manager',
                icon: 'solar:share-circle-broken',
                exact: false,
                visible: isFeatureEnabled('model-manager') && (isModelModerator.value || isAdmin.value),
            },
            {
                name: 'Admin',
                route: 'admin-portal',
                icon: 'solar:lock-broken',
                exact: false,
                visible: isAdmin.value,
            },
        ].filter((item) => item.visible),
    );

    return { navigation };
}
